import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { TownParams } from './service';

export enum TownActions {
  Failure = '[Catalogs Town] Failure',
  Request = '[Catalogs Town] Request',
  Success = '[Catalogs Town] Success',
}

export const TownFailure = createAction(TownActions.Failure, props<{ error: HttpErrorResponse }>());

export const TownRequest = createAction(TownActions.Request, props<{ parameters: TownParams }>());

export const TownSuccess = createAction(TownActions.Success, props<{ data: ParameterResult }>());
